import { Grid } from "@material-ui/core";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import { defaultToastSuccess, defaultToastError } from "App/utils/helpers";
import React from "react";
import { TableItemTransfer } from "./TabBarang";
import { TableJasa } from "./TabJasa";
import { useState } from "react";

import {
  ITEM_TYPE_FASILITAS,
  RESET_TAB_MODAL,
} from "pages/Penjualan/Master/Rikjang/constants";
import {
  deleteItemById,
  addItemById,
} from "pages/Penjualan/Master/Rikjang/api";
import { RikjangFormItem } from "pages/Penjualan/Master/Rikjang/form/RikjangFormItem";

function TabFasilitas({ formData, setFormData, paketID }) {
  const [formFasilitas, setFormFasilitas] = useState(RESET_TAB_MODAL);
  const [showModal, setShowModal] = useState(false);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleClickSelect = async (row) => {
    setFormFasilitas({
      id: "",
      item_type: ITEM_TYPE_FASILITAS,
      item_id: row.id,
      name: row.nama,
      qty: 1,
    });
    setShowModal(!showModal);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const fasilitas = formData.fasilitas;
      const checkFasilitas = fasilitas.filter(
        (e) => e.item_id === formFasilitas.item_id
      );
      if (checkFasilitas.length === 0) {
        if (formData.isUpdate) {
          const res = await addItemById(
            {
              paket_id: paketID,
              item_type: ITEM_TYPE_FASILITAS,
              item_id: formFasilitas.item_id,
              qty: formFasilitas.qty,
            },
            "paket"
          );
          if (res.state) {
            fasilitas.push({
              id: res.data.id,
              paket_id: paketID,
              item_type: ITEM_TYPE_FASILITAS,
              item_id: formFasilitas.item_id,
              namaFasilitas: formFasilitas.name,
              qty: formFasilitas.qty,
            });

            setFormData({
              ...formData,
              fasilitas,
            });
            defaultToastSuccess(res.message);
          } else {
            defaultToastError(res.message);
          }

          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        } else {
          fasilitas.push({
            item_type: ITEM_TYPE_FASILITAS,
            item_id: formFasilitas.item_id,
            namaFasilitas: formFasilitas.name,
            qty: formFasilitas.qty,
          });

          setFormData({
            ...formData,
            fasilitas,
          });

          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        }
      } else {
        defaultToastError("Fasilitas sudah ada");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      }
    } catch (error) {}
  };

  const clickDelete = async (row) => {
    const fasilitas = formData.fasilitas;
    const checkFasilitas = fasilitas.filter((e) => e.item_id !== row.item_id);
    setFormData({
      ...formData,
      fasilitas: checkFasilitas,
    });
    if (formData.isUpdate) {
      const res = await deleteItemById(row.id, "paket");
      if (res.state) {
        defaultToastSuccess(res.message);
      } else {
        defaultToastError(res.message);
      }
    }
  };

  return (
    <div>
      {showModal && (
        <RikjangFormItem
          setShowModal={() => setShowModal(false)}
          form={formFasilitas}
          setForm={setFormFasilitas}
          disabled={disabled}
          handleSubmit={handleSubmit}
        />
      )}

      <Grid container spacing={2}>
        <Grid item sm={6}>
          <TableJasa
            url='/master/fasilitas/ms_fasilitas/listMsFasilitas'
            handleClickSelect={handleClickSelect}
            title='Daftar Fasilitas'
          />
        </Grid>

        <Grid item sm={6}>
          <TableItemTransfer
            filter='namaFasilitas'
            rows={formData.fasilitas}
            clickDelete={clickDelete}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default TabFasilitas;
